import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent  implements OnInit {

    @Input()
    title: any;

    @Input()
    description: any;

    constructor(public activeModal: NgbActiveModal) {
    }

    isValid() {
        return true;
    }

    ngOnInit() {
    }


    onCancel() {
        this.activeModal.dismiss();
    }

    onSuccess() {
        this.activeModal.close({});
    }

}
